import React from "react";
import runes from "runes";

interface TitleLayersProps {
    title: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    styles: any;
}

const emojiRegex = /\p{Extended_Pictographic}/u;

const wrapEmojis = (text: string) => {
    const asArray = runes(text);

    return asArray.map((char, ind) => {
        if (emojiRegex.test(char)) {
            return (
                <span key={ind} className="emoji">
                    {char}
                </span>
            );
        }

        return char;
    });
};

const TitleLayers: React.FC<TitleLayersProps> = ({ title, styles }) => {
    return (
        <>
            <div className={`title ${styles.title}`} data-title={title}>
                {wrapEmojis(title)}
            </div>
            <div
                className={`title title-copy--1 ${styles.title}`}
                data-title={title}
            >
                {wrapEmojis(title)}
            </div>
            <div
                className={`title title-copy--2 ${styles.title}`}
                data-title={title}
            >
                {wrapEmojis(title)}
            </div>
            <div
                className={`title title-copy--3 ${styles.title}`}
                data-title={title}
            >
                {wrapEmojis(title)}
            </div>
            <div
                className={`title title-copy--4 ${styles.title}`}
                data-title={title}
            >
                {wrapEmojis(title)}
            </div>
        </>
    );
};

export default TitleLayers;
